__turbopack_context__.v({
  "statusCell": "StatusCell-module__eNtY9q__statusCell",
  "statusCell__icon": "StatusCell-module__eNtY9q__statusCell__icon",
  "statusCell__indicator": "StatusCell-module__eNtY9q__statusCell__indicator",
  "statusCell__indicator__bar": "StatusCell-module__eNtY9q__statusCell__indicator__bar",
  "statusCell__indicator__barCompleted": "StatusCell-module__eNtY9q__statusCell__indicator__barCompleted",
  "statusCell__indicator__barEmpty": "StatusCell-module__eNtY9q__statusCell__indicator__barEmpty",
  "statusCell__label": "StatusCell-module__eNtY9q__statusCell__label",
});
